import store from "@/state/store";
import PostGridView from "@/views/posts/PostGridView.vue";
// import PostListView from "@/views/posts/PostListView.vue";
// import PostDetailView from "@/views/posts/PostDetailView.vue";

export default [
  // {
  //   path: "/",
  //   name: "home",
  //   component: () => import("../views/dashboard/projects/index"),
  //   meta: { title: "Accueil", authRequired: true },
  // },

  {
    path: "/",
    name: "home",
    component: () => import("@/views/posts/FeedView.vue"),
    meta: { title: "Accueil", authRequired: true },
  },

  //   {
  //   path: "/",
  //   name: "home",
  //   component: () => import("@/views/test.vue"),
  //   meta: { title: "Accueil", authRequired: true },
  // },

  {
    path: "/post",
    name: "posts-grid",
    component: PostGridView,
    meta: { title: "Posts - Grid View", authRequired: true },
  },

  // dashboard routes
  {
    path: "/projects-dashboard",
    name: "projects-dashboard",
    component: () => import("../views/dashboard/projects/index"),
    meta: { title: "Dashboard", authRequired: true },
  },

  {
    path: "/app-dashboard",
    name: "app-dashboard",
    component: () => import("../views/dashboard/analytics/index"),
    meta: { title: "Dashboard", authRequired: true },
  },

  {
    path: "/activity-dashboard",
    name: "activity-dashboard",
    component: () => import("../views/dashboard/crm/index"),
    meta: { title: "Dashboard", authRequired: true },
  },

  // User Profile routes
  {
    path: "/login",
    name: "login",
    component: () => import("../views/userProfile/index"),
    meta: {
      title: "Login",
      public: true,
      noLockscreen: true, // Exclure du lockscreen
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/logout",
    name: "logout",
    meta: {
      public: true,
      noLockscreen: true,
      title: "logout",
      authRequired: true,
    },
    component: () => import("@/views/userProfile/user-Logout.vue"),
  },

  {
    path: "/policy",
    name: "policy",
    component: () => import("@/views/userProfile/user-Policy.vue"),
    meta: {
      title: "Policy",
      authRequired: true,
    },
  },

  {
    path: "/conditions",
    name: "conditions",
    component: () => import("@/views/userProfile/term-conditions.vue"),
    meta: {
      title: "conditions",
      authRequired: true,
    },
  },

  {
    path: "/lock",
    name: "LockScreen",
    meta: { title: "LockScreen", authRequired: true },
    component: () => import("@/views/userProfile/user-LockScreen.vue"),
  },

  {
    path: "/forgot-password",
    name: "Forgot-password",
    component: () => import("../views/userProfile/user-Forgot.vue"),
    meta: {
      title: "Forgot Password",
      public: true,
      noLockscreen: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("../views/userProfile/user-Reset.vue"),
    meta: {
      title: "Forgot Password",
      public: true,
      noLockscreen: true,
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },

  {
    path: "/profile",
    name: "Profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("@/views/userProfile/user-Profile.vue"),
  },

  // router/index.js
  {
    path: "/user-profile/:userId",
    name: "UserProfile",
    component: () => import("@/views/userProfile/userProfileView.vue"),
    meta: { requiresAuth: true },
  },

  // router/index.js
  {
    path: "/employee-profile/:employeeId/employee",
    name: "EmployeeProfile",
    component: () => import("@/views/userProfile/employeeProfileView.vue"),
    meta: { requiresAuth: true },
  },

  // Dans votre router (ex: router/index.js)
  {
    path: "/employees/birthdays",
    name: "Birthdays",
    component: () => import("@/views/employee/BirthdaysView.vue"),
    meta: {
      title: "Anniversaires",
      requiresAuth: true,
    },
  },

  {
    path: "/settings",
    name: "Settings",
    meta: { title: "Settings", authRequired: true },
    component: () => import("@/views/userProfile/user-Settings.vue"),
  },

  // Modules Permissions routes
  {
    path: "/permissions",
    name: "permissions",
    meta: { title: "Permissions", authRequired: true, permission: 'permissions' },
    component: () => import("../views/permissions/permissions-crud"),
  },

  // Modules Category Documents routes
  {
    path: "/category-document",
    name: "category-document",
    meta: { title: "Category Document", authRequired: true, permission: 'document:categories' },
    component: () =>
      import("../views/category-document/category-document-crud"),
  },

  // Modules Types de modèles routes
  {
    path: "/template-types",
    name: "template-types",
    meta: { title: "Template Types", authRequired: true, permission: 'template:types' },
    component: () => import("../views/template-types/template-types-crud"),
  },
  // Modules Bocs de modèles routes
  {
    path: "/template-bloc",
    name: "template-bloc",
    meta: { title: "Template Bloc", authRequired: true, permission: 'template:bloc' },
    component: () => import("../views/template-bloc/template-bloc-crud"),
  },
  // Modules de modèles routes
  {
    path: "/template",
    name: "template",
    meta: { title: "Template", authRequired: true, permission: 'templates' },
    component: () => import("../views/template/template-crud"),
  },
  // Modules de modèles routes
  {
    path: "/category-ticket",
    name: "category-ticket",
    meta: { title: "Category Ticket", authRequired: true },
    component: () => import("../views/category-ticket/category-ticket-crud"),
  },

  // Modules Roles routes
  {
    path: "/roles",
    name: "roles",
    meta: { title: "Roles", authRequired: true, permission: 'roles' },
    component: () => import("../views/roles/roles-crud"),
  },

  // Modules User routes
  {
    path: "/user-management",
    name: "user-usersList",
    meta: {
      title: "Users List",
      authRequired: true,
      permission: 'users',
    },
    component: () => import("../views/userManagement/index"),
  },

  // Modules grade routes
  {
    path: "/grades",
    name: "grade",
    meta: {
      title: "grade",
      authRequired: true,
    },
    component: () => import("../views/grade/index"),
  },

  // Modules countries routes
  {
    path: "/pays",
    name: "pays",
    meta: {
      title: "pays",
      authRequired: true,
    },
    component: () => import("../views/country/index"),
  },

  // Modules echelon routes
  {
    path: "/echelons",
    name: "echelon",
    meta: {
      title: "echelon",
      authRequired: true,
    },
    component: () => import("../views/echelon/index"),
  },

  // Modules formation routes
  {
    path: "/formations",
    name: "formation",
    meta: {
      title: "formations",
      authRequired: true,
    },
    component: () => import("../views/formation/index"),
  },

  // Modules missions routes
  {
    path: "/missions",
    name: "mission",
    meta: {
      title: "mission",
      authRequired: true,
    },
    component: () => import("../views/mission/index"),
  },

  // Modules echelon routes
  {
    path: "/denunciations",
    name: "denunciation",
    meta: {
      title: "denunciation",
      authRequired: true,
    },
    component: () => import("../views/denunciation/index"),
  },

  // Modules statusEmployee routes
  {
    path: "/status",
    name: "status",
    meta: {
      title: "status",
      authRequired: true,
    },
    component: () => import("../views/statusEmployee/index"),
  },

  // Modules eventType routes
  {
    path: "/events",
    name: "event",
    meta: {
      title: "event",
      authRequired: true,
    },
    component: () => import("../views/eventType/index"),
  },

  // Modules employee job routes
  {
    path: "/jobs",
    name: "job",
    meta: {
      title: "job",
      authRequired: true,
    },
    component: () => import("../views/job/index"),
  },

  // Modules departureType routes
  {
    path: "/departures",
    name: "departure",
    meta: {
      title: "departure",
      authRequired: true,
    },
    component: () => import("../views/departureType/index"),
  },

  // Modules inactivityType routes
  {
    path: "/inactivities",
    name: "inactivity",
    meta: {
      title: "inactivity",
      authRequired: true,
    },
    component: () => import("../views/inactivityType/index"),
  },

  // Modules sanctionType routes
  {
    path: "/sanctions",
    name: "sanction",
    meta: {
      title: "sanction",
      authRequired: true,
    },
    component: () => import("../views/sanctionType/index"),
  },

  // Modules holiday routes
  {
    path: "/holidays",
    name: "holiday",
    meta: {
      title: "holiday",
      authRequired: true,
    },
    component: () => import("../views/holiday/index"),
  },

  // Modules leaveType routes
  {
    path: "/leaves",
    name: "leave",
    meta: {
      title: "leave",
      authRequired: true,
    },
    component: () => import("../views/leaveType/index"),
  },

  // Modules fileType routes
  {
    path: "/files",
    name: "file",
    meta: {
      title: "file",
      authRequired: true,
      permission: 'file:types',
    },
    component: () => import("../views/fileType/index"),
  },

  // Modules reportType routes
  {
    path: "/reports-type",
    name: "report-type",
    meta: {
      title: "report",
      authRequired: true,
    },
    component: () => import("../views/reportType/index"),
  },

  // Modules attribute routes
  {
    path: "/attributes",
    name: "attribute",
    meta: {
      title: "attribute",
      authRequired: true,
    },
    component: () => import("../views/attribute/index"),
  },
  // Modules de mots clés document
  {
    path: "/keyword",
    name: "keyword",
    meta: { title: "Mots-clés", authRequired: true, permission: 'keywords' },
    component: () => import("../views/keyword/keyword-crud"),
  },
  // Modules productCategory routes
  {
    path: "/products",
    name: "product",
    meta: {
      title: "product",
      authRequired: true,
    },
    component: () => import("../views/productCategory/index"),
  },
  // Modules d'institution type
  {
    path: "/institution-type",
    name: "institution-type",
    meta: { title: "Institution type", authRequired: true, permission: 'institution:types' },
    component: () => import("../views/institution-type/institution-type-crud"),
  },
  // Modules de mots clés document
  {
    path: "/movement-type",
    name: "movement-type",
    meta: { title: "Movement type", authRequired: true },
    component: () => import("../views/movement-type/movement-type-crud"),
  },
  // Modules de Support types
  {
    path: "/support-type",
    name: "support-type",
    meta: { title: "Support type", authRequired: true },
    component: () => import("../views/support-type/support-type-crud"),
  },
  // Modules de groupes
  {
    path: "/group",
    name: "group",
    meta: { title: "Group", authRequired: true, permission: 'groups' },
    component: () => import("../views/group/group-crud"),
  },
  // Modules de compétences
  {
    path: "/knowledge",
    name: "knowledge",
    meta: { title: "Knowledge", authRequired: true },
    component: () => import("../views/knowledge/knowledge-crud"),
  },

  // Modules Organisations
  {
    path: "/organizations",
    name: "organizations",
    meta: { title: "Organisations", authRequired: true, superAdmin: true },
    component: () => import("../views/organizations/organization-crud"),
  },
  {
    path: "/organizations/settings",
    name: "organization-settings",
    component: () => import("@/views/organizations/settings.vue"),
    meta: { title: "Paramètres organisation", authRequired: true, superAdmin: true },
  },

  // Modules de Directions
  {
    path: "/direction",
    name: "direction",
    meta: { title: "Direction", authRequired: true },
    component: () => import("../views/direction/direction-crud"),
  },

  // Modules de Services
  {
    path: "/service",
    name: "service",
    meta: { title: "Service", authRequired: true },
    component: () => import("../views/service/service-crud"),
  },

  // Modules person routes
  {
    path: "/person",
    name: "person",
    meta: {
      title: "person",
      authRequired: true,
    },
    component: () => import("../views/person/index"),
  },

  // Modules employee routes
  {
    path: "/employee",
    name: "employee",
    meta: {
      title: "employee",
      authRequired: true,
    },
    component: () => import("../views/employee/index"),
  },

  // Modules ticket routes
  {
    path: "/ticket",
    name: "ticket",
    meta: {
      title: "ticket",
      authRequired: true,
    },
    component: () => import("../views/ticket/kanban"),
  },

  {
    path: "/ticket-list",
    name: "ticket-list",
    meta: {
      title: "ticket",
      authRequired: true,
    },
    component: () => import("../views/ticket/list-view"),
  },

  {
    path: "/create-ticket",
    name: "create-ticket",
    meta: {
      title: "ticket",
      authRequired: true,
    },
    component: () => import("../views/ticket/create"),
  },

  {
    path: "/:ticketId/ticket-details",
    name: "ticket-details",
    meta: {
      title: "ticket",
      authRequired: true,
    },
    component: () => import("../views/ticket/details"),
  },

  {
    path: "/tickets/:ticketId/edit",
    name: "ticket-edit",
    meta: {
      title: "ticket",
      authRequired: true,
    },
    component: () => import("../views/ticket/edit"),
  },

  // Modules Partners
  {
    path: "/partners",
    name: "partners",
    meta: { title: "Partners", authRequired: true, permission: 'partners' },
    component: () => import("../views/partners/partners-crud"),
  },

  // Modules Meetings
  {
    path: "/meetings",
    name: "meetings",
    meta: { title: "Meetings", authRequired: true },
    component: () => import("../views/meetings/meeting-crud"),
  },

  // Modules Reports
  {
    path: "/report",
    name: "report",
    meta: { title: "Reports", authRequired: true },
    component: () => import("../views/report/report-crud"),
  },

  // Modules Institution routes
  {
    path: "/institution",
    name: "institution",
    meta: { title: "Institution", authRequired: true, permission: 'institution:read' },
    component: () => import("../views/institution/index"),
  },

  // Modules tasks routes
  {
    path: "/tasks",
    name: "tasks",
    meta: { title: "Tasks", authRequired: true },
    component: () => import("../views/tasks/index"),
  },

  // Modules posts
  // {
  //   path: "/post",
  //   name: "posts-grid",
  //   component: PostGridView,
  //   meta: { title: "Posts - Grid View", authRequired: true },
  // },
  // {
  //   path: "/posts/list",
  //   name: "posts-list",
  //   component: PostListView,
  //   meta: { title: "Posts - List View", authRequired: true },
  // },
  // {
  //   path: "/posts/:id",
  //   name: "post-detail",
  //   component: PostDetailView,
  //   meta: { title: "Post Details", authRequired: true },
  // },
  {
    path: "/posts/create",
    name: "post-create",
    component: () => import("@/views/posts/PostFormPage.vue"),
    meta: { authRequired: true },
  },
  {
    path: "/posts/edit/:id",
    name: "post-edit",
    component: () => import("@/views/posts/PostFormPage.vue"),
    meta: { authRequired: true },
  },
  {
    path: "/posts",
    name: "feed",
    component: () => import("@/views/posts/FeedView.vue"),
    meta: { requiresAuth: true },
  },

  // modules workflows
  {
    path: "/workflows",
    name: "workflows",
    component: () => import("@/views/workflow/index.vue"),
    meta: { title: "Workflows", requiresAuth: true },
  },
  {
    path: "/workflows/editor/:id",
    name: "workflow-editor",
    component: () => import("@/views/workflow/WorkflowEditor.vue"),
    meta: { title: "Éditeur de Workflow", requiresAuth: true },
    props: true,
  },
  {
    path: "/workflows/instances",
    name: "workflow-instances",
    component: () => import("@/views/workflow/WorkflowInstances.vue"),
    meta: { title: "Instances de Workflow", requiresAuth: true },
  },
  {
    path: "/workflows/instances/:id",
    name: "workflow-instance-details",
    component: () => import("@/views/workflow/WorkflowInstanceDetails.vue"),
    meta: { title: "Détails Instance", requiresAuth: true },
    props: true,
  },
  {
    path: "/workflows/details/:id",
    name: "workflow-details",
    component: () => import("@/views/workflow/WorkflowDetails.vue"),
    meta: { title: "Détails du Workflow", requiresAuth: true },
    props: true,
  },

  // modules pour hierarchie des employés
  {
    path: "/hierarchies",
    name: "hierarchies",
    component: () => import("@/views/hierarchy/index.vue"),
    meta: { authRequired: true },
  },

  // modules pour diplomes
  {
    path: "/diplomas",
    name: "diplomas",
    component: () => import("@/views/diploma/index.vue"),
    meta: { authRequired: true },
  },

  // modules pour categories de postes
  {
    path: "/jobCategories",
    name: "jobCategories",
    component: () => import("@/views/jobCategory/index.vue"),
    meta: { authRequired: true },
  },

  // modules pour professions
  {
    path: "/professions",
    name: "professions",
    component: () => import("@/views/profession/index.vue"),
    meta: { requiresAuth: true },
  },

  // modules pour structure organisationnelle
  {
    path: "/structures",
    name: "structures",
    component: () => import("@/views/structure/index.vue"),
    meta: { requiresAuth: true, permission: 'structure:read' },
  },
    {
    path: "/structures-organigramme",
    name: "structures-organigramme",
    component: () => import("@/views/structure/OrganigramView.vue"),
    meta: { requiresAuth: true },
  },

  // modules Paramètres
  {
    path: "/parameters",
    name: "parameters",
    meta: { title: "Parameters", authRequired: true },
    component: () => import("../views/parameters/parameters-crud.vue"),
  },
  // modules pour gestion de dossiers et documents
  {
    path: "/drive",
    name: "drive",
    component: () => import("@/views/file-manager/DriveView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/drive/:folderId",
    name: "drive-folder",
    component: () => import("@/views/file-manager/DriveView.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/drive/file/:id",
    name: "file-detail",
    component: () => import("@/views/file-manager/FileDetailView.vue"),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: "/drive/recent",
    name: "recent",
    component: () => import("@/views/file-manager/RecentView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/drive/shared",
    name: "shared",
    component: () => import("@/views/file-manager/SharedView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/drive/starred",
    name: "starred",
    component: () => import("@/views/file-manager/StarredView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/drive/trash",
    name: "trash",
    component: () => import("@/views/file-manager/TrashView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/drive/search",
    name: "search",
    component: () => import("@/views/file-manager/SearchView.vue"),
    meta: { requiresAuth: true },
  },
];
